<!-- klikany kontener w stylu <mat-form-field> -->
<div class="multiselectblock">

  <div
    class="as-select"
    #triggerEl
    [class.disabled]="disabled"
    (click)="togglePanel()"
    (keydown)="onKeydown($event)"
    tabindex="0"
    [attr.aria-expanded]="panelOpen"
    role="combobox"
    [attr.aria-multiselectable]="multiple" 
    [attr.aria-owns]="panelId"
  >
    <!-- placeholder lub wybrane chipy -->
    <ng-container *ngIf="!selectedOptions?.length; else chips">
      <div class="placeholder">{{ placeholder }}</div>
    </ng-container>

    <ng-template #chips>
      <div class="chip" *ngFor="let o of selectedOptions; trackBy: trackByValue">
        {{ getLabel(o) }}
        <button
          type="button"
          class="remove"
          aria-label="Usuń {{ getLabel(o) }}"
          (click)="removeOption(o, $event)"
        >
        <div class="delete">×</div>
        </button>
      </div>
    </ng-template>

    <div class="arrow" aria-hidden="true">▾</div>
  </div>

  <!-- panel opcji (CDK Overlay) -->
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="overlayOrigin"
    [cdkConnectedOverlayMinWidth]="overlayWidth"
    [cdkConnectedOverlayWidth]="overlayWidth"
    [cdkConnectedOverlayOpen]="panelOpen"
    (backdropClick)="closePanel()"
    (detach)="panelOpen = false"
    [cdkConnectedOverlayHasBackdrop]="true"
  >
    <div
      class="as-select-panel"
      #panel
      [id]="panelId"
      role="listbox"
       [attr.aria-multiselectable]="multiple"
    >
      <label
        *ngFor="let opt of options; trackBy: trackByValue"
        class="option"
        [class.selected]="isSelected(opt)"
      >
        <input
          [type]="multiple ? 'checkbox' : 'radio'"
          [checked]="isSelected(opt)"
          (change)="toggleOption(opt, $event)"
          class="visually-hidden"
        />
        {{ getLabel(opt) }}
      </label>
    </div>
  </ng-template>

  <span

  cdkOverlayOrigin
  #overlayOrigin="cdkOverlayOrigin"
  class="cdk-anchor"
></span>
</div>

